var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "30px",
    viewBox: "0 0 27 30",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4884 6.39846L14.9932 0.40118C14.0659 -0.133727 12.9219 -0.133727 11.9946 0.40118L1.49932 6.39846C0.570046 6.93531 -0.00194412 7.92901 4.99091e-06 9.00272L4.99091e-06 20.9973C-0.00194912 22.071 0.570046 23.0647 1.49932 23.6015L11.9946 29.5988C12.9219 30.1337 14.0659 30.1337 14.9932 29.5988L25.4884 23.6015C26.4177 23.0647 26.9897 22.071 26.9877 20.9973L26.9877 9.00272C26.9897 7.92901 26.4177 6.93531 25.4884 6.39846ZM23.989 20.9973L13.4938 26.9946L2.99854 20.9973L2.99854 9.00277L13.4938 3.00549L23.989 9.00277L23.989 20.9973Z",
    id: "Fill-1",
    fill: "#E54A4A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9933 20.4975C14.9933 22.4966 11.9946 22.4966 11.9946 20.4975C11.9946 18.4985 14.9933 18.4985 14.9933 20.4975",
    id: "Fill-2",
    fill: "#E54A4A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9946 15.4998L14.9933 15.4998L14.9933 8.00323L11.9946 8.00323L11.9946 15.4998Z",
    id: "Fill-3",
    fill: "#E54A4A",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.b9202c7a3557a8b8adecd09f63ae8ab0.svg";
export { ForwardRef as ReactComponent };